equalheight = function(container){
    $('.row-equal-height').each(function(i,e) {
        var $this = $(e),
            $childs = $this.find(container),
            height = 0;

        $childs.css('height', '');
        $childs.each(function(i,e){
            if($(e).outerHeight() > height) {
                height = $(e).outerHeight();
            }
        });
        $childs.css('height', height);
    });
};